<template>
  <!-- TrustBox widget - Horizontal -->
  <div
    class="trustpilot-widget"
    data-locale="en-GB"
    data-template-id="5406e65db0d04a09e042d5fc"
    data-businessunit-id="55f8267a0000ff0005835745"
    data-style-height="28px"
    data-style-width="100%"
    data-theme="light"
    ref="trustpilotWidget"
    style="text-align: center"
  >
    <a
      href="https://uk.trustpilot.com/review/www.splitthebills.co.uk"
      target="_blank"
      rel="noopener"
      >Trustpilot</a
    >
  </div>
  <!-- End TrustBox widget -->
</template>

<script>
export default {
  name: "TrustpilotWidget",
  mounted() {
    const trustbox = this.$refs.trustpilotWidget;

    function loadTrustpilot() {
      if (!window.Trustpilot) {
        window.setTimeout(loadTrustpilot, 1000);
      } else {
        window.Trustpilot.loadFromElement(trustbox);
      }
    }

    loadTrustpilot();
  },
};
</script>

<style lang="scss">
.trustpilot-widget {
  margin-bottom: 1rem;
}
</style>
